const $ = require('jquery');

export function navigation() {
	
    //ADA Compliance roles
    $(".menu .sub-menu").attr("role","menubar");
    $(".menu li").attr("role","menuitem");

    $( function () {
        // Focus styles for menus when using keyboard navigation
        // Properly update the ARIA states on focus (keyboard) and mouse over events
        $( '[role="menubar"]' ).on( 'focus.aria  mouseenter.aria', '[aria-haspopup="true"]', function ( ev ) {
            $( ev.currentTarget ).attr( 'aria-expanded', true );
        });

        // Properly update the ARIA states on blur (keyboard) and mouse out events
        $( '[role="menubar"]' ).on( 'blur.aria  mouseleave.aria', '[aria-haspopup="true"]', function ( ev ) {
            $( ev.currentTarget ).attr( 'aria-expanded', false );
        });
    });

    $('.js-menu-toggle').click( function () {
        $(this).toggleClass('active');
        $('li.menu-item-has-children.active').removeClass('active');
        $('.js-search-toggle').removeClass('active');
        $('body').removeClass("active-search");
        $('body').toggleClass("active-nav");
    });

    $('#primary-menu a').click( function () {
        $('.js-menu-toggle').removeClass('active');
        $('li.menu-item-has-children.active').removeClass('active');
        $('body').removeClass("active-nav");
    });

    $('.js-search-toggle').click( function () {
        $(this).toggleClass('active');
        $('li.menu-item-has-children.active').removeClass('active');
        $('body').removeClass("active-nav");
        $('body').toggleClass("active-search");
        $('.utiltiy-nav .search-form input.search-field').focus();
    });


    //Mobile Nav Expandable Children
    $( "#primary-menu ul.sub-menu" ).wrap( "<div class='sub-menu-wrapper'></div>" );
    
    $("#primary-menu li.menu-item-has-children").each( function() {
        const $children = $(this).find('> a').text();
        $(this).find('> a').after( $("<button class='mobile sub-menu-toggle'>View Children of " + $children + "</botton>") );	
    });

    $('.sub-menu-toggle').click(function() { 
        $(this).parent('li.menu-item-has-children').toggleClass('active');	
    });  
      
    $("#primary-menu ul.sub-menu").each( function() {
        $(this).prepend( $("<li class='menu-item menu-item-back'><button class='mobile sub-menu-back'><span class='icon-prev'></span>Back</botton></li>") );	
    });
    
    $('.sub-menu-back').click(function() { 
        $(this).closest('li.menu-item-has-children.active').removeClass('active');	
    });
    
    $('#rental-mini-open').click(function() { 
        $('body').addClass('mini-rental-active');	
    });
    
    $('#rental-mini-close').click(function() { 
        $('body').removeClass('mini-rental-active');	
    });
    
    let width = $(window).width();
    $(window).resize(function(){
        if($(this).width() !== width){
            width = $(this).width();
            $('.js-menu-toggle').removeClass('active');
            $('body').removeClass("active-nav");
            $('.js-search-toggle').removeClass('active');
            $('body').removeClass("active-search");
            $('li.menu-item-has-children.active').removeClass('active');
            $('body').removeClass('mini-rental-active');
        }
    });
    
    $('li.menu-item a[href="#"]').addClass('disabled');
    
    
    
}